import { OrigamiUrls } from '@app/origami-api/constants';
import { DOCUMENT_MANAGER_SERVICE_URL } from '@app/origami-api/services/document-manager.service';

// I assume that this function will not be used in heavy cycles; otherwise we need an optimization
export function getAbsoluteUrl(url) {
  const a = document.createElement('a');
  a.href = url;

  const result = a.href;
  a.remove();

  return result;
}

export function getDocumentAttachmentUrl(
  roomId: number,
  topicId: number,
  attachmentId?: number,
  clonedToRoomId?: number,
  clonedToDocumentId?: number,
) {
  // this is for published TMF applicable documents
  if (clonedToRoomId && clonedToDocumentId) {
    return getAbsoluteUrl(`#document-viewer/${clonedToRoomId}/${clonedToDocumentId}`);
  }

  return OrigamiUrls.openTopicFileWithUrl
    .replace(/{serviceName}/, `${DOCUMENT_MANAGER_SERVICE_URL}`)
    .replace(/{siteId}/, `${roomId}`)
    .replace(/{TopicId}/, `${topicId}`)
    .replace(/{attachmentId}/, `${attachmentId || 0}`);
}
